import { render, staticRenderFns } from "./PromosList.vue?vue&type=template&id=b7c6fda0"
import script from "./PromosList.vue?vue&type=script&lang=js"
export * from "./PromosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports